import Capitulo from './Capitulo'
import Tabela from './Tabela'
import Fluxograma from './Fluxograma'
import Figura from './Figura'
import Medicamento from './Medicamento'
import Aula from './Aula'
import Webinar from './Webinar'
import Artigo from './Artigo'
import Podcast from './Podcast'
import Diretriz from './Diretriz'
import ConsultaRapidaERecomendacoes from './ConsultaRapidaERecomendacoes'
import DiagnosticoETratamento from './DiagnosticoETratamento'
import HabilidadesClinicas from './HabilidadesClinicas'

export { 
    Capitulo,
    Tabela,
    Fluxograma,
    Figura,
    Medicamento,
    Aula,
    Webinar,
    Artigo,
    Podcast,
    Diretriz,
    ConsultaRapidaERecomendacoes,
    DiagnosticoETratamento,
    HabilidadesClinicas
}



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/index.js